import * as React from 'react';

interface IPanelProps {
  children: React.ReactNode;
}

const PageHeader = ({ children }: IPanelProps) => <h1 className="page-header text-overflow">{children}</h1>;

export { PageHeader };
